import script from "./HrScrollArea.vue?vue&type=script&setup=true&lang=js"
export * from "./HrScrollArea.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QScrollArea});
